var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.948 3.85152L15.2319 16.3046C15.027 17.1836 14.4926 17.4023 13.7332 16.9882L9.59484 14.0234L7.59797 15.8906C7.37698 16.1054 7.19216 16.2851 6.76627 16.2851L7.06359 12.1875L14.7337 5.44918C15.0672 5.16012 14.6614 4.99996 14.2154 5.28902L4.73323 11.0937L0.651091 9.85152C-0.236855 9.58199 -0.252927 8.98824 0.835913 8.57418L16.8029 2.59371C17.5422 2.32418 18.189 2.75387 17.948 3.85152Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.29b2c8c5bb89ef5423bbc255872be5af.svg";
export { ForwardRef as ReactComponent };